import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import Migas from './components/migas';
import Home from './pages/home';
import Header from './components/header';
import Footer from './components/footer';
import About from './pages/about';
import AvisoLegal from './pages/avisoLegal.jsx';
import PoliticaPrivacidad from './pages/politicaPrivacidad.jsx';
import PoliticaCookies from './pages/politicaCookies.jsx';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme } from './theme/lightTheme';
import { darkTheme } from './theme/darkTheme';
import LoginModal from './pages/loginModal';
import HowHelp from './pages/howHelp.jsx';
import OurSpaces from './pages/ourSpaces.jsx';
import Profile from './pages/profile.jsx';
import Usuarios from './admin/usuarios';
import EditUsuarios from './admin/editUsuarios';
import Roles from './admin/roles';
import CreateRole from './admin/createRole';
import AdminDashboard from './admin/adminDashboard.jsx';
import Page404 from './pages/page404';
import ErrorPage from './pages/error';
import EmployeeDashboard from './employee/employeeDashboard.jsx';
import EmployeeAppointments from './employee/employeeAppointments.jsx';
import EmployeeForms from './employee/employeeForms.jsx';
import EmployeeArticles from './employee/employeeArticles.jsx';
import EmployeeClients from './employee/employeeClients.jsx';
import UserAvailability from './employee/userAvailability.jsx';
import { styled } from '@mui/material/styles';
//import { useDispatch, useSelector } from'react-redux';
import * as endPoints from './assets/js/endpoints';
import Sidebar from './components/sidebar';
import Calendar from './pages/calendar';
import './css/global.css';
// import useGlobalFadeIn from './hooks/useGlobalFadeIn';
//import ShowForm from './pages/formResponses.jsx';
import CreateForm from './pages/createForm';
import ManageForms from './admin/manageForms.jsx';
import ManageArticles from './admin/manageArticles.jsx';
import ManageClients from './admin/manageClients.jsx';
import CreateClient from './admin/createClient.jsx';
import ManageReports from './admin/manageReports.jsx';
import ManageActivities from './admin/manageActivities.jsx';
import ClientHistory from './admin/clientHistory.jsx';
import CreateReport from './admin/createReport.jsx';
import ManageServices from './admin/manageServices.jsx';
import CreateService from './admin/createService.jsx';
import ManageCategories from './admin/manageCategories.jsx';
import CreateCategory from './admin/createCategory.jsx';
import ManageMedia from './admin/manageMedia.jsx';
import EmployeeReports from './employee/employeeReports.jsx';
import Register from './admin/register';
import CreateArticle from './pages/createArticle.jsx';
import FormResponses from './admin/formResponses.jsx';
import FormFill from './pages/formFill.jsx';
import JoinUs from './pages/joinUs.jsx';
import Blog from './pages/blog.jsx';
import Article from './pages/article.jsx';
import ScrollToTop from './components/scrollToTop.jsx';
import { UserContext } from './assets/contexts/userContext.jsx';
import BackToTop from './components/backToTop.jsx';
import Contactanos from './pages/contactanos.jsx';
import PideTuCita from './pages/pideTuCita.jsx';
import Formaciones from './pages/formaciones.jsx';
import CesExperience from './pages/cesExperience.jsx';
import ManageFormations from './admin/manageFormations.jsx';

const drawerWidth = 220; // Fijo para pantallas grandes
const drawerCollapsedWidth = 60; // Ancho cuando está cerrado

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }),
);

const openedStyles = {
  marginLeft: `${drawerWidth}px`,
  backgroundColor: 'transparent',
  minHeight: '50vh',
};

const closedStyles = {
  marginLeft: `${drawerCollapsedWidth}px`,
  backgroundColor: 'transparent',
  minHeight: '50vh',
};

const notUserStyles = {
  marginLeft: '0px',
  backgroundColor: 'transparent',
  minHeight: 'auto',
};

const footerOpenedStyles = {
  marginLeft: `${drawerWidth}px`,
};

const footerClosedStyles = {
  marginLeft: `${drawerCollapsedWidth}px`,
};

const sidebarRoutePrefixes = [
  '/admin',
  '/employee',
  '/pages/profile',
  '/pages/createForm',
  '/pages/calendar',
  '/blog/createArticle',
  '/blog/editar',
  '/blog',
  '/form/',
];






// export const UserContexto = createContext();




const App = () => {
  const [theme] = useState('light');
  const { user, logout } = useContext(UserContext);

  const [open, setOpen] = useState(true);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const [formularios, setFormularios] = useState([]);

  useEffect(() => {
    const getAllForms = async () => {
      setFormularios(await endPoints.getAllForms());
    };
    getAllForms();
  }, []);

  useEffect(() => {
    if (user.isLogged) {
      document.body.style.backgroundColor = '#f0f0f0';
    } else {
      document.body.style.backgroundColor = '';
    }
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, [user.isLogged]);

  return (
    <div className='app'>
      <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
        <CssBaseline />
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AppContent
            user={user}
            logout={logout}
            open={open}
            handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose}
            formularios={formularios}
          />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
};

const AppContent = ({ user, logout, open, handleDrawerOpen, handleDrawerClose, formularios }) => {
  const location = useLocation();
  const shouldShowSidebar =
    user.isLogged && sidebarRoutePrefixes.some((prefix) => location.pathname.startsWith(prefix));

  const renderProtected = (condition, component) => (condition ? component : <Page404 />);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {!shouldShowSidebar && <ScrollToTop />}
      {shouldShowSidebar ? (
        <Sidebar
          user={user}
          logout={logout}
          open={open}
          drawerWidth={drawerWidth}
          drawerCollapsedWidth={drawerCollapsedWidth}
          handleDrawerOpen={handleDrawerOpen}
          handleDrawerClose={handleDrawerClose}
          formularios={formularios}
        />
      ) : (
        <Header formularios={formularios} />
      )}
      <Main open={open} sx={shouldShowSidebar ? (open ? openedStyles : closedStyles) : notUserStyles}>
        {shouldShowSidebar && <Migas />}
        <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/about" element={<About />} />
    <Route path="/howHelp" element={<HowHelp />} />
    <Route path="/ourSpaces" element={<OurSpaces />} />
    <Route path="/formaciones" element={<Formaciones />} />
    <Route path="/unete-a-nosotras" element={<JoinUs formularios={formularios} />} />
    <Route path="/pide-tu-cita" element={<PideTuCita />} />
    <Route path="/contactanos" element={<Contactanos />} />
    <Route path="/propuesta-web-2026" element={<CesExperience />} />
    <Route path="/admin/manageForms" element={renderProtected(user.hasRole('admin'), <ManageForms />)} />
    <Route path="/admin/manageArticles" element={renderProtected(user.hasRole('admin'), <ManageArticles />)} />
    <Route path="/admin/manageClients" element={renderProtected(user.hasRole('admin'), <ManageClients />)} />
    <Route path="/admin/manageReports" element={renderProtected(user.hasRole('admin'), <ManageReports />)} />
    <Route path="/admin/manageActivities" element={renderProtected(user.hasRole('admin'), <ManageActivities />)} />
    <Route path="/admin/clinicalHistory/:clientId" element={renderProtected(user.hasRole('admin'), <ClientHistory />)} />
    <Route path="/employee/clinicalHistory/:clientId" element={renderProtected(user.hasRole('employee'), <ClientHistory />)} />
    <Route path="/admin/manageServices" element={renderProtected(user.hasRole('admin'), <ManageServices />)} />
    <Route path="/admin/manageFormations" element={renderProtected(user.hasRole('admin'), <ManageFormations />)} />
    <Route path="/admin/manageCategories" element={renderProtected(user.hasRole('admin'), <ManageCategories />)} />
    <Route path="/admin/manageMedia" element={renderProtected(user.hasRole('admin'), <ManageMedia />)} />
    <Route path="/admin/createClient" element={renderProtected(user.hasRole('admin'), <CreateClient />)} />
    <Route path="/admin/createClient/:id" element={renderProtected(user.hasRole('admin'), <CreateClient />)} />
    <Route path="/admin/createReport" element={renderProtected(user.hasRole('admin'), <CreateReport />)} />
    <Route path="/admin/createReport/:id" element={renderProtected(user.hasRole('admin'), <CreateReport />)} />
    <Route path="/admin/createService" element={renderProtected(user.hasRole('admin'), <CreateService />)} />
    <Route path="/admin/createService/:id" element={renderProtected(user.hasRole('admin'), <CreateService />)} />
    <Route path="/admin/createCategory" element={renderProtected(user.hasRole('admin'), <CreateCategory />)} />
    <Route path="/admin/createCategory/:id" element={renderProtected(user.hasRole('admin'), <CreateCategory />)} />
    <Route path="/employee/createClient" element={renderProtected(user.hasRole('employee'), <CreateClient />)} />
    <Route path="/employee/createClient/:id" element={renderProtected(user.hasRole('employee'), <CreateClient />)} />
    <Route path="/employee/createReport" element={renderProtected(user.hasRole('employee'), <CreateReport />)} />
    <Route path="/employee/createReport/:id" element={renderProtected(user.hasRole('employee'), <CreateReport />)} />
    <Route path="/pages/createForm" element={renderProtected(user.isLogged, <CreateForm />)} />
    <Route path="/pages/createForm/:id" element={renderProtected(user.isLogged, <CreateForm />)} />
     {/* PÚBLICO: llenar un formulario dinámico */}
    <Route path="/form/:slug" element={<FormFill formularios={formularios}/>} />
    {/* ADMIN: ver respuestas de un formulario */}
    <Route path="/admin/manageForms/formResponses/:formId" element={renderProtected(user.hasRole('admin'), <FormResponses formularios={formularios} />)} />
    {/* EMPLEADO: ver respuestas de un formulario */}
    <Route path="/employee/forms/formResponses/:formId" element={renderProtected(user.hasRole('employee'), <FormResponses formularios={formularios} />)} />
    {/* <Route path="/formulario/:slug/:id/:name" element={<FormFill />} /> */}
    <Route path="/avisoLegal" element={<AvisoLegal />} />
    <Route path="/politicaPrivacidad" element={<PoliticaPrivacidad />} />
    <Route path="/politicaCookies" element={<PoliticaCookies />} />
    <Route path="/login" element={<LoginModal   />} />     
    <Route path="/employee/employeeDashboard" element={renderProtected(user.hasRole('employee'), <EmployeeDashboard />)} />
    <Route path="/employee/citas" element={renderProtected(user.hasRole('employee'), <EmployeeAppointments />)} />
    <Route path="/employee/disponibilidad" element={renderProtected((user.hasRole('employee') || user.hasRole('admin')), <UserAvailability />)} />
    <Route path="/employee/clientes" element={renderProtected(user.hasRole('employee'), <EmployeeClients />)} />
    <Route path="/employee/forms" element={renderProtected(user.hasRole('employee'), <EmployeeForms />)} />
    <Route path="/employee/articles" element={renderProtected(user.hasRole('employee'), <EmployeeArticles />)} />
    <Route path="/employee/reports" element={renderProtected(user.hasRole('employee'), <EmployeeReports />)} />
    <Route path="/pages/calendar" element={<Calendar />} />
    <Route path="/pages/profile" element={renderProtected(user.id !== null, <Profile />)} />
    <Route path="/pages/profile/:id" element={<Profile />} />
    <Route path="/pages/profile/:id/:name" element={<Profile />} />
    <Route path="/pages/profile/:id/:name/:role" element={<Profile />} />
    <Route path="/pages/profile/:id/:name/:role/:email" element={<Profile />} />
    <Route path="/pages/profile/:id/:name/:role/:email/:created_at" element={<Profile />} />
    <Route path="/pages/profile/:id/:name/:role/:email/:created_at/:image" element={<Profile />} />
    <Route path="/pages/profile/:id/:name/:role/:email/:created_at/:image/:description" element={<Profile />} />
    <Route path="/pages/profile/:id/:name/:role/:email/:created_at/:image/:description/:phone" element={<Profile />} />
    <Route path="/blog" element={<Blog />} />
    <Route path="/blog/:id" element={<Article />} />
    <Route path="/blog/createArticle" element={renderProtected(user.hasPermission('article.create'), <CreateArticle />)} />
    {/* <Route path="/blog/editar/:id" element={(user.hasPermission('article.edit') || user.hasPermission('article.ownerEdit')) ? <CreateArticle /> : <LoginModal />} /> */}
    <Route path="/blog/editar/:id" element={renderProtected((user.hasRole('admin') || user.hasPermission('article.ownerEdit')), <CreateArticle />)} />
    <Route path="/admin/usuarios" element={renderProtected(user.hasRole('admin'), <Usuarios />)} />
    <Route path="/admin/usuarios/editar/:id" element={renderProtected(user.hasRole('admin'), <EditUsuarios />)} />
    <Route path="/admin/roles" element={renderProtected(user.hasRole('admin'), <Roles />)} />
    <Route path="/admin/roles/crear" element={renderProtected(user.hasRole('admin'), <CreateRole />)} />
    <Route path="/admin/roles/editar/:id" element={renderProtected(user.hasRole('admin'), <CreateRole />)} />
    <Route path="/admin/registro" element={renderProtected(user.hasRole('admin'), <Register />)} />
    <Route path="/admin/adminDashboard" element={renderProtected(user.role === 'admin', <AdminDashboard />)} />
    <Route path="/error" element={<ErrorPage />} />
    <Route path="*" element={<Page404 />} />
    
        </Routes>
      </Main>
      {!shouldShowSidebar && <Footer />}
      <BackToTop />
    </div>
  );
};

export default App;
